<script lang="ts">
  import {createEventDispatcher, getContext} from 'svelte';
  import Modal from '@/widgets/Modal.svelte';
  import {WalletType} from '../componets/wallet/utils';
  import lang from '../LoginPage.lang';

  let LLG;
  export let width = 24;
  export {LLG as LG};
  export let metamaskIcon: string;
  export let walletConnectIcon:string;

  const LG = getContext('LG') || LLG;
  const dispatch = createEventDispatcher();

  function handleClickFun(type) {
    return function(){
      dispatch('open', {type});
      setTimeout(()=> {
        dispatch('close');
      }, 100)
    }
  }

  function handleClickClose() {
      setTimeout(()=> {
        dispatch('close');
      }, 100);
  }
</script>

<style>
  .c-black{
    color: #000;
  }
  .bg-grey{
    background: #E9ECF2;
    padding: 0 20px;
    height: 48px;
    border-radius: 48px;
    text-transform: capitalize;
  }

</style>
<div class="wallet-login-modal">
  <Modal style="width: 396px;" showCloseIcon2 on:close={handleClickClose}>
    <div class="modal-wallet" >
      <div class="f20 fw3 lh24 c-black">{LG(lang.ConnectWallet)}</div>
      <div class="mt8 f16 lh22 c-black">
        {LG(lang.ConnectWalletDesc)}
      </div>
      <div class="pr" on:click|stopPropagation={handleClickFun(WalletType.Metamask)}>
        <div class="mt16 bg-grey c-black df aic f12 lh16 cp">
          <img width={width} height={width} src={metamaskIcon} class="mr12"/>
          MetaMask
        </div>
      </div>
      <div class="pr" on:click|stopPropagation={handleClickFun(WalletType.WalletConnect)}>
        <div class="mt12 bg-grey c-black df aic f12 lh16 cp">
          <img width={width} height={width} src={walletConnectIcon} class="mr12"/>
          Wallet Connect
        </div>

      </div>
    </div>
  </Modal>
</div>
